import { useUser } from '~/api/hooks/useGetAccount';
import { useGetFeetCharacteristics } from '~/api/hooks/useGetFeetCharacteristics';
import { useLocale } from '~/hooks/useLocale';
import type { DateString } from '~/interfaces/common';

export const useGrowthPhase = (date?: DateString) => {
  const { data: user } = useUser();
  const { lang } = useLocale();
  const { data } = useGetFeetCharacteristics({ child_id: user?.selected_child_id, date, lang });

  return { data };
};
